import React from "react";
import { TYPE_PC, TYPE_SP } from "./defines";
import { modal } from "./modal";
import { filterNearestAssets, getAssetUrl } from "../lib/masterUtil";
import masterData from "../lib/masterData";
import { Link } from "../lib/Link";
import Slider from "react-slick";
import api from "../lib/api";
import { MapControl } from "../pages/area/MapControl";

let slicks = [];
let _swiping;

const lists = (assets) => {
  return (assets.map((asset, index) => {
    const assetIcon = masterData.assetIcon.bySlug[asset.assetIcon];
    return (
      <Link
        to={getAssetUrl(asset)}
        key={index}
        shouldLinkHandler={() => {
          return !_swiping;
        }}
        className="item"
      >
        <div className="collection">
          <img src={api.assetImageUrl(asset.assetId, asset.images[0], 0)} />
          <div>
            <div className="type">
              <div>
                <img src={assetIcon && assetIcon.icon} />
              </div>
            </div>
            <div className="title">{asset.name}</div>
          </div>
        </div>
        <div className="address">{asset.address}</div>
      </Link>
    );
  })
  );
}

const SUBURBS_DISTANCE = 5;

function distance(lat1, lng1, lat2, lng2) {
  if (lat1 === null || lat1 === undefined) return SUBURBS_DISTANCE;
  if (lat2 === null || lat2 === undefined) return SUBURBS_DISTANCE;
  if (lng1 === null || lng1 === undefined) return SUBURBS_DISTANCE;
  if (lng2 === null || lng2 === undefined) return SUBURBS_DISTANCE;
  lat1 *= Math.PI / 180;
  lng1 *= Math.PI / 180;
  lat2 *= Math.PI / 180;
  lng2 *= Math.PI / 180;
  return 6371 * Math.acos(Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) + Math.sin(lat1) * Math.sin(lat2));
}

const suburbslist = (target) => {
  const assetAll = masterData.asset.list;
  let nearlist = [];
  let list = [];
  list.push(target);
  assetAll.forEach(asset => {
    if (asset.geo !== null && asset.geo !== undefined && target.geo !== null && target.geo !== undefined) {
      const dist = distance(asset.geo.lat, asset.geo.lng, target.geo.lat, target.geo.lng);
      if (dist < SUBURBS_DISTANCE && dist !== 0) {
        nearlist.push({data: asset , dist: dist});
      }
    }
  });
  nearlist.sort(function(a,b){
    if(a.dist < b.dist) return -1;
    if(a.dist > b.dist) return 1;
    return 0;
  });
  nearlist.forEach(asset => {
    list.push(asset.data)
  });
  return list;
}

/* eslint-disable max-params */
export const history_list = (type, isSuburbs, asset, history) => {
  let assets = [];
  if (isSuburbs) {
    assets = suburbslist(asset);
  } else {
    const assetIds =
      JSON.parse(localStorage.getItem("assetHistory") || null) || [];
    assets = assetIds
      .slice(0, 10)
      .map(assetId => masterData.asset.byId[assetId]);
    assets = assets.filter(_asset => _asset && _asset.assetId !== asset.assetId);
  }
  const isSlider = type == TYPE_PC ? (assets.length > 4) : (assets.length > 0);

  return (
    <div className="history_list">
      <div className="title">
        {isSuburbs ? "近郊のトランクルーム" : "最近見た物件"}
      </div>
      {isSuburbs ? (
        <div className="area_map mapcontent">
          <div className="container mapcontent">
            <div className="content mapcontent">
              <div className="control mapcontent">
                <MapControl
                  list={assets || [asset]}
                  history={history}
                  type={type}
                  target={asset}
                  isDetail={true}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
          <div></div>
        )}
      {isSlider ? (
        <Slider
          className="collection"
          dots={false}
          infinite={false}
          speed={800}
          slidesToShow={type == TYPE_PC ? 4 : 1}
          slidesToScroll={1}
          swipeEvent={() => {
            _swiping = true;
          }}
          ref={(_slick) => {
            if (!_slick || _slick in slicks) return;
            slicks.push(_slick);
            let _end = _slick.innerSlider.swipeEnd;
            _slick.innerSlider.swipeEnd = (e) => { _end(e); setTimeout(() => { _swiping = false; }, 500) }
          }}
        >
          {lists(assets.filter(_asset => _asset && _asset.assetId !== asset.assetId))}
        </Slider>
      ) : (
          <div className="collection">
            {lists(assets.filter(_asset => _asset && _asset.assetId !== asset.assetId))}
          </div>
        )}
    </div>
  );
};




// WEBPACK FOOTER //
// ./common/history_list.jsx